import { ChangeDetectionStrategy, Component, forwardRef, Input, signal, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CardOptionComponent } from './components/card-option/card-option.component';
import { CardOptionType } from './contracts/card-option-type.contract';

@Component({
  selector: 'osp-card-option-list',
  standalone: true,
  imports: [CardOptionComponent],
  templateUrl: './card-option-list.component.html',
  styleUrl: './card-option-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CardOptionListComponent),
    },
  ],
})
export class CardOptionListComponent implements ControlValueAccessor {
  @Input() options!: CardOptionType[];
  @Input() title?: string;
  @Input() selectable: boolean = true;
  protected selectedOption = signal<string | null>(null);

  private onChange: (value: string | null) => void = () => {};
  private onTouch: () => void = () => {};

  handleCardClicked(type: string): void {
    if (this.selectedOption() === type) {
      this.selectedOption.set(null);
      this.onChange(null);
    } else {
      this.selectedOption.set(type);
      this.onChange(type);
    }
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(selectedValue: string | null): void {
    this.selectedOption.set(selectedValue);
  }
}
